export enum HttpStatus {
  BAD_GATEWAY = 502,
  BAD_REQUEST = 400,
  CONFLICT = 409,
  FORBIDDEN = 403,
  GATEWAY_TIMEOUT = 504,
  INTERNAL_SERVER_ERROR = 500,
  NO_CONTENT = 204,
  NOT_FOUND = 404,
  NOT_MODIFIED = 304,
  OK = 200,
  UNAUTHORIZED = 401,
  UNPROCESSABLE_ENTITY = 422,
}
